// m端图片详情页2s自动显示询价弹窗 & 离开时强制弹出询价弹窗
import React, { useState, useEffect, useRef } from "react";
import AskpricePopFromBottom from "@component/picPagePopUp/askpricePopFromBottom/index";
import AskpricePopFromLeave from "@component/picPagePopUp/askpricePopFromLeave/index";
import { removeCookie } from "newcar-ui/output/cjs/utils/tools";
import { addVconsole } from "newcar-ui/output/cjs/utils/vconsole";
addVconsole();
let App = () => {
  const askpricePopFromBottomRef = useRef();
  const askpricePopFromLeaveRef = useRef();
  const [cityId, setCityId] = useState();
  useEffect(() => {
    if (window.getCity) {
      window.getCity((cityInfo) => {
        setCityId(cityInfo.cityid);
      });
    }
    askpricePopFromLeaveRef.current.showLeavePop();
    // 外部暴露显示底部弹窗方法
    window.openAskpricePopFormBottom =
      askpricePopFromBottomRef.current.showBottomPop;
    window.clearcookie = () => {
      // 清理cookie
      removeCookie(`picAskpricePopFormBottom_${window.lineId}`);
      removeCookie(`picAskpricePopFromLeave_${window.lineId}`);
      window.sessionStorage.removeItem("pushstated");
    };
  }, []);
  useEffect(() => {
    if (cityId && askpricePopFromBottomRef.current) {
      askpricePopFromBottomRef.current.showBottomPop();
    }
  }, [cityId]);
  return (
    <>
      <AskpricePopFromBottom
        ref={askpricePopFromBottomRef}
        lineId={window.lineId}
        productId={window.productId}
        cityId={cityId}
      ></AskpricePopFromBottom>
      <AskpricePopFromLeave
        ref={askpricePopFromLeaveRef}
        lineId={window.lineId}
        productId={window.productId}
        cityId={cityId}
      ></AskpricePopFromLeave>
    </>
  );
};

export default App;
